import React, { FC } from 'react'

import { TrustIcon } from '@Components/Icons'
import { Link } from '@Components/Link'
import { getMobileNavEvent, Icons, TrustIconProps } from '@Components/TrustIcons/common'

export const TrustIconsNL: FC<TrustIconProps> = ({ variant }: TrustIconProps) => (
  <Icons variant={variant}>
    <Link
      event={getMobileNavEvent('thuiswinkel', variant)}
      href="https://www.thuiswinkel.org/leden/trendhim-aps/certificaat"
      rel="noopener noreferrer"
      target="_blank"
    >
      <TrustIcon image="frontend/trust-logos/thuiswinkel-logo.png" />
    </Link>

    <div>
      <TrustIcon image="frontend/trust-logos/ecommerce-eu-logo.png" />
    </div>
  </Icons>
)
